import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_DASHBOARD_INFO,
    GET_DASHBOARD_OPTIONS
} from "./actionTypes.js";

import { dashboardInfoApi, dashboardOptionsApi } from "./dashboardApi.js";
import { getDashboardInfoFail, getDashboardInfoSuccess, getDashboardOptionsFail, getDashboardOptionsSuccess } from "./actions.js";

function* fetchDashboardInfo({ payload }) {
    try {
        const response = yield call(dashboardInfoApi, payload)
        yield put(getDashboardInfoSuccess(response))
    } catch (error) {
        yield put(getDashboardInfoFail(error))
    }
}

function* fetchDashboardOptions({ payload }) {
    try {
        const response = yield call(dashboardOptionsApi, payload)
        yield put(getDashboardOptionsSuccess(response))
    } catch (error) {
        yield put(getDashboardOptionsFail(error))
    }
}

function* DashboardSaga() {
    yield takeEvery(GET_DASHBOARD_INFO, fetchDashboardInfo)
    yield takeEvery(GET_DASHBOARD_OPTIONS, fetchDashboardOptions)
}

export default DashboardSaga
